{
  "id": "campaign-154",
  "name": "Weedy Vale",
  "seed": "campaign:154",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ",,,,.....k,,,,,,,,",
    "..,,.....,,,,,,,,,",
    "..,,...#.,,,,,,,,,",
    "...Y,...,,,,,.h.h,",
    ",...,,,,,,,,,...,,",
    ",...,,,,,,,,,...,,",
    ",,,,,,,,,,,,,,,,,,",
    ",,,,,,,T,,,,,,,,,,",
    "h,,,,,,,,...,,,,..",
    ",,,,,,,,.,,,,,,,..",
    ",,,,,,,,,,,,T,,,..",
    ",,,,,,,,,,,,,,,,,,",
    ",,,,,,,,,,,,,,,,.h",
    ",,,Y,,,,,,,,,,,...",
    ",,,,,,,,,,,,,,,...",
    ",,,,,,,,,,,,,,,...",
    ",,,,,,,,,,,,,,,#..",
    ",,,,,,,,,,,,,,...S"
  ],
  "critters": [
    {
      "kind": "deer",
      "x": 5,
      "y": 1
    },
    {
      "kind": "deer",
      "x": 5,
      "y": 0
    },
    {
      "kind": "stag",
      "x": 14,
      "y": 5
    },
    {
      "kind": "fox",
      "x": 17,
      "y": 9
    },
    {
      "kind": "deer",
      "x": 3,
      "y": 5
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 13,
      "y": 12
    },
    {
      "kind": "gas",
      "x": 6,
      "y": 1
    },
    {
      "kind": "gas",
      "x": 2,
      "y": 10
    },
    {
      "kind": "gas",
      "x": 11,
      "y": 1
    },
    {
      "kind": "gas",
      "x": 17,
      "y": 11
    },
    {
      "kind": "gas",
      "x": 8,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 13,
      "y": 11
    },
    {
      "kind": "repair",
      "x": 10,
      "y": 1
    }
  ],
  "hills": [
    {
      "x": 8,
      "y": 7,
      "w": 3,
      "h": 3
    },
    {
      "x": 12,
      "y": 3,
      "w": 5,
      "h": 5
    }
  ],
  "generatorVersion": 3,
  "level": 154,
  "biome": "meadow",
  "par": {
    "reel": 12892,
    "push": 11186,
    "selfPropelled": 10214,
    "tractor": 8513,
    "zeroTurn": 7426,
    "fairway": 3984
  },
  "goldTime": {
    "reel": 12892,
    "push": 11186,
    "selfPropelled": 10214,
    "tractor": 8513,
    "zeroTurn": 7426,
    "fairway": 3670
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 23
    },
    "gold": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 47
    }
  }
}
